import { render, staticRenderFns } from "./addressAutocomplete.vue?vue&type=template&id=0995c672&"
import script from "./addressAutocomplete.vue?vue&type=script&lang=js&"
export * from "./addressAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports